import client from "../axios";
import { DefaultService } from "./DefaultService";
import { HttpStatusCode } from "../HttpStatusCode";

export default class AppointmentService extends DefaultService {
  static entityUrl = "appointments";

  static getHoursAvailableInterval(
    clinic_id: number | string,
    startDate: string,
    endDate: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      return client
        .get(`${AppointmentService.entityUrl}/${clinic_id}/${startDate}/${endDate}`)
        .then((response) => {
          if (response.status === HttpStatusCode.OK) resolve(response);
          else reject(response.statusText);
        })
        .catch((error) => reject(error));
    });
  }

  static getHoursAvailable(clinic_id: number | string, date: string): Promise<any> {
    return new Promise((resolve, reject) => {
      return client
        .get(`${AppointmentService.entityUrl}/${clinic_id}/${date}`)
        .then((response) => {
          if (response.status === HttpStatusCode.OK) resolve(response);
          else reject(response.statusText);
        })
        .catch((error) => reject(error));
    });
  }

  static getClinicGroupAvailableHours(date: string, data: { [index: string]: any }): Promise<any> {
    const arrayIds = {
      clinic_ids: data
    };
    return new Promise((resolve, reject) => {
      return client
        .post(`${AppointmentService.entityUrl}/${date}`, arrayIds)
        .then((response) => {
          if (response.status === HttpStatusCode.OK) resolve(response);
          else reject(response.statusText);
        })
        .catch((error) => reject(error));
    });
  }

  static getAppointment(crx_id: number | string, env: string): Promise<any> {
    return new Promise((resolve, reject) => {
      return client
        .get(`${AppointmentService.entityUrl}/get-by-crxid?crx_id=${crx_id}&env=${env}`)
        .then((response) => {
          if (response.status === HttpStatusCode.OK) resolve(response);
          else reject(response.statusText);
        })
        .catch((error) => reject(error));
    });
  }

  static setAppointment(data: { [index: string]: any }): Promise<any> {
    return new Promise((resolve, reject) => {
      return client
        .post(AppointmentService.entityUrl, data)
        .then((response) => {
          if (response.status === HttpStatusCode.CREATED || response.status === HttpStatusCode.OK) {
            if (response.data && response.data.success === false) {
              reject(response.data.join("\n"));
            } else {
              resolve(response);
            }
          } else reject(response.data.join("\n"));
        })
        .catch((error) => reject(error));
    });
  }
}
